import Vue from 'vue'
import Vuex from 'vuex'
import filters from '../data/filters.json'

//TODO: actually use store correctly (setters)

Vue.use(Vuex)

// root state object.
// each Vuex instance is just a single state tree.
const state = {
    homing: {
        //error: false,
        //brakesReleased: true,
        //hardwareReady: true
    },
    decodedLicenseKey: null,
    layoutViewer: [],
    homingCanceled: false,
    machineSettings: {
        company: {
            logo: null,
            locality: null,
            address: null,
            department: null,
            costCenter: null,
            responsible: null
        },
        password: {
            lowerLetter: false,
            upperLetter: false,
            specialLetter: false,
            numberLetter: false,
            wordLength: 1
        },
        license: null,
        logoutTime: null
    },
    jogControlAnswer: null,
    savedPositions: [],
    teachingCorrections: [],
    teachingPositions: [],
    slots: [],
    empower: null,
    vials: {},
    status: {
        statusCommandStatus: 'halt',
        queueing: false,
        noActiveDispatcherTask: false,
        pause: true,
        safe: true,
        unlockingRequest: false,
        unlocked: false,
        homingOk: true,
        overrideMode: false,
        haltProcessingRequest: false,
        processingHalted: false,
        portOpen: false,
        emergencyActive: false,
        pumpActive: [],
    },
    shaker: [],    
    handlerControlResponse: {
        responses: [],
    },
    handlerControlCmdList: '',
    roles: [
        'operator',
        'creator',
        'superuser',
        'administrator',
        'superadmin'
    ],
    user: {
        name: 'Demo',
        pass: null,
        role: 'superuser',
        logoutTime: 10*60*60*1000,
        prename: null,
        surname: null,
        employeeNumber: null,
        department: null,
        email: null,
        phone: null,
        mobile: null,
        img: null,
        approve: false,
        inactive: false,
        passValidDays: null,
        passCreateDate: null
    },
    users: [],
    projects: [],
    pumps: [{"solvent":"Acetonitrile","name":"LM1_ND1","loopSize":50,"operationalTimePump":92580,"needleCounter":0,"operationalTimeLoop":0},{"solvent":"Acetonitrile2","name":"LM1_ND2","loopSize":50,"operationalTimePump":59532,"needleCounter":128,"operationalTimeLoop":0}],
    workflow: {
        steps: []
    },
    filters,
    filterDispenser: {
        filter: null,
    },
    maintenanceMonitor: [],
    referenceDataViewer: null,
    //IOControlResponse: [],
    IOControlTaskList: [],
    balanceControlAnswer: {
        answer: ''
    },
    maintenancePassword: null,
    missingConsumables: null,
    shakerControlAnswer: {},
    lcFeeder: {},
    reposition: [],
    solvents: [],
}


// mutations are operations that actually mutates the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
const mutations = {

    setWorkflow(state, workflow) {
        state.workflow = {
            ...workflow,
            steps: (workflow.typedSteps || workflow.steps).map(step=>({...step, valid: true})),
            originalDescription: workflow.description,
            originalName: workflow.name,
        };
    }
}

// actions are functions that cause side effects and can involve
// asynchronous operations.
const actions = {
  
    loadWorkflow({ commit }, fileName) {
        this._vm.$api.compatibilityEmit('loadWorkflow', fileName, (workflow)=>{
            commit('setWorkflow', workflow);
        })
    },
    importWorkflow({ commit }, content) {
        commit('setWorkflow', JSON.parse(content));
    }
}

// getters are functions
const getters = {
}

// A Vuex instance is created by combining the state, mutations, actions,
// and getters.
export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations
})